export const preventPublishingToNbIfNotAllowed = (museumIdsWithNbAccess, selectedTags, docs) => {
    // If "NB" is selected, please verify that the user has access to publish
    // to all of the museums of the selected objects.
    //
    // ISSUE: Known issue, if the user is tagging the selection of objects with multiple tags,
    // documents that belongs to a museum the user does not have access to publish to NB will not be tagged at all.
    // Not even with the remaining tags, as it is removed from the list of documents to tag.
    if (selectedTags.some(t => t.publishingType === 'nb')) {
        return [...docs].filter(doc => {
            return museumIdsWithNbAccess.some(m => m.collectionId === doc.collectionId);
        });
    }
    return docs;
};